import { api } from "../api.js";
import { escapeHtml, fmtDate } from "../format.js";

export async function renderMethodology({ root, isCurrent }) {
  document.title = "Metodologia · Como Vota";
  const data = await api.methodology();
  if (!isCurrent()) return;
  const leaders = data.government_leaders || [];
  const coalitions = data.government_coalitions || [];
  root.innerHTML = `
    <article class="detail">
      <header class="detail__head">
        <h1 class="detail__title">Metodologia</h1>
        <p class="muted">Como calculamos presença, fidelidade partidária, alinhamento com o governo, resumos e próximos passos.</p>
      </header>
      <section class="prose">${data.html || "<p>Em construção.</p>"}</section>
      <section class="detail__section">
        <h2 class="section-title">Líderes do governo considerados</h2>
        ${
          leaders.length
            ? `<div class="table-wrap"><table class="table"><thead><tr><th>Casa</th><th>Parlamentar</th><th>Início</th><th>Fim</th></tr></thead><tbody>${leaders
                .map(
                  (l) =>
                    `<tr><td>${escapeHtml(l.house)}</td><td>${escapeHtml(l.name)}</td><td>${fmtDate(l.start_date)}</td><td>${l.end_date ? fmtDate(l.end_date) : "atual"}</td></tr>`,
                )
                .join("")}</tbody></table></div>`
            : `<p class="muted">Nenhum líder cadastrado.</p>`
        }
      </section>
      <section class="detail__section">
        <h2 class="section-title">Base governista (coalizão) por período</h2>
        ${
          coalitions.length
            ? `<div class="table-wrap"><table class="table"><thead><tr><th>Partido</th><th>Início</th><th>Fim</th><th>Observação</th></tr></thead><tbody>${coalitions
                .map(
                  (c) =>
                    `<tr><td>${escapeHtml(c.sigla)}</td><td>${fmtDate(c.start_date)}</td><td>${c.end_date ? fmtDate(c.end_date) : "atual"}</td><td class="muted">${escapeHtml(c.note || "")}</td></tr>`,
                )
                .join("")}</tbody></table></div>`
            : `<p class="muted">Nenhuma coalizão cadastrada.</p>`
        }
      </section>
    </article>`;
}
